import { PrintLabelItem } from "../types/PrintLabelItem";
import { v4 as uuidv4 } from "uuid";

export type LabelPrintItem = {
  fnsku: string;
  itemName: string;
  count: number;
};

export type ExpirationLabelItem = {
  expirationDate: string;
  count: number;
};

/**
 * ラベル印刷用のウィンドウを開く（ダイアログから印刷ラベル表示）
 * @param items ラベル印刷対象の商品リスト
 */
export const openPrintLabelWindow = (items: LabelPrintItem[]) => {
  if (!items || items.length === 0) return;

  const query = encodeURIComponent(JSON.stringify(items));
  const url = `/printLabel?items=${query}`;
  const printWindow = window.open(url, "_blank");

  if (!printWindow) {
    alert("ポップアップブロックにより印刷ウィンドウを開けませんでした。");
  }
};

// 日本語対応のBase64エンコード
export const safeBase64Encode = (str: string) =>
  btoa(unescape(encodeURIComponent(str)));

/**
 * ラベル印刷用のウィンドウを開く（一覧画面から印刷ラベル表示）
 * @param items ラベル印刷対象の商品リスト
 */
export const openPrintLabelsWindow = (items: PrintLabelItem[]) => {
  const key = `print-label-${uuidv4()}`;
  localStorage.setItem(key, JSON.stringify(items));
  window.open(`/printLabels?key=${key}`, "_blank");
};

export const openPrintExpirationLabelWindow = (
  items: ExpirationLabelItem[]
) => {
  const key = `expiration-label-${uuidv4()}`;
  localStorage.setItem(key, JSON.stringify(items));
  window.open(`/printExpirationLabels?key=${key}`, "_blank");
};
